import { useState, useEffect } from 'react';
import {
  Box, Typography, Container, Pagination,
} from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';
import CardRating from './CardRating';

function Reviews({ reviewData, averageRating }) {
  const [slicedReviews, setSlicedReviews] = useState([]);

  useEffect(() => {
    if (reviewData?.length > 0) setSlicedReviews(reviewData?.slice(0, 4));
  }, [reviewData]);

  const handlePagination = (page) => {
    const first = (page - 1) * 4;
    const last = page * 4;
    setSlicedReviews(reviewData?.slice(first, last));
  };

  if (!reviewData) {
    console.log('keine Bewertungsdaten vorhanden');
    return null;
  }

  return (
    <Wrapper>
      <Typography variant="h2" className="headline">Bewertungen</Typography>
      <Typography className="subline">
        Durchschnittlich
        <strong>
          {' '}
          {averageRating}
          {' '}
        </strong>
        aus insgesamt
        <strong>
          {' '}
          {reviewData.length}
          {' '}
        </strong>
        Bewertungen.
      </Typography>
      <CardContainer sx={
        slicedReviews.length >= 4
          ? { justifyContent: 'space-between' }
          : { justifyContent: 'flex-start' }
      }
      >
        {slicedReviews.map((review, index) => (
          <CardRating key={index} rating={review} />
        ))}

        {
          reviewData.length > 4
            ? (
              <StyledPagination
                onChange={(e, value) => handlePagination(value)}
                count={
                  reviewData.length > 0
                    ? Math.ceil(reviewData.length / 4)
                    : 1
                }
              />
            )
            : null
        }
      </CardContainer>
    </Wrapper>
  );
}

export default Reviews;

// Styling
const Wrapper = styled(Container, {})({
  '& .headline': {
    marginBottom: 20,
  },

  '& .subline': {
    ...theme.typography.p16,

    marginBottom: 20,
  },
});

const CardContainer = styled(Box, {})({
  display: 'flex',
  paddingLeft: 0,
  height: '100%',

  gap: 24,
  flexDirection: 'column',
  flexWrap: 'no-wrap',
  alignItems: 'top',

  [theme.breakpoints.up('laptop')]: {
    height: 640,

    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

const StyledPagination = styled(Pagination, {})({
  alignSelf: 'flex-end',

  display: 'flex',
  width: '100%',

  justifyContent: 'center',

  '& .MuiPaginationItem-root': {
    background: theme.palette.white,

    '&.Mui-selected': {
      background: theme.palette.newSecondary,
    },

    '&:hover': {
      background: theme.palette.midgrey,
    },
  },
});
